/**
 *
 * @param isSuccess 是否成功，成功后执行success回调函数
 * @param data
 */
function parentClose(isSuccess, data) {
  // eslint-disable-next-line no-undef
  if(window.layerId&&window.layerId.length){
    window.childWindow.pop();
    let index = window.layerId.pop();
    let callback = window.childWindowSuccess.pop();
    if(index>=0){
      window.layer && window.layer.close(index)
      if(isSuccess){
        callback(data);
      }
    }
  } else {
    window.layer && window.layer.closeAll()
    window.layerId = []
    window.childWindow = []
    window.childWindowSuccess = []
  }
}

export default parentClose
